import React from 'react';
import "../style/AppPages.css";
import { useNavigate } from "react-router-dom";

const OrderFailedPage = ()  => {
    const navigate = useNavigate();

  return (
    <div class="page-padding">
      <h1>Order Failed</h1>
      <p>Sorry, we were unable to complete your order at this time. Please check your method of payment and try again.</p>
      <button onClick={() => navigate("/checkout")}>Go to cart checkout</button>
      <button onClick={() => navigate("/")}>Go to homepage</button>
    </div>
  );
}

export default OrderFailedPage;